export default "__VITE_ASSET__Dl7keg7q__"